import { subscribe, emit, events } from './eventManager.js';
function emitTrial(trial, error = false) {
    emit(events.TRIAL, trial, error);
}
function setTrial(trial) {
    window.disw.trial = trial;
    emitTrial(trial);
}
function subscribeToTrial(callback) {
    return subscribe(events.TRIAL, callback);
}
export default {
    emitTrial,
    setTrial,
    subscribeToTrial,
};
